import { getMaintenanceInfo } from 'services/EnforceAppAPIHelper'
import i18n from 'utils/I18n';
import {
    getCMSLanguage,
} from 'utils/LanguageCheckUtil';
const defaultState = {
    maintenanceInfo: {},
}
const putMaintenance = (data) => {
    if (!data?.active) {
        return
    }
    const active = data.active
    let item = data
    if (i18n.language != "en") {
        const translations = data.translations || []
        item = translations.find(item => item.language == getCMSLanguage(i18n.language))
    }
    return {
        active,
        description: item?.description || i18n.t("enforceApp:maintenanceDescription"),
        title: item?.title || i18n.t("enforceApp:maintenanceTitle"),
    }
}

export default {
    namespace: 'enforceApp',
    state: defaultState,
    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
        resetState(state) {
            return defaultState
        },
    },

    effects: {
        getMaintenanceInfo: [
            function* ({ payload }, { call, put }) {
                const response = yield call(getMaintenanceInfo)
                if (response && response.status < 300) {
                    const data = response.data
                    const maintenanceInfo = putMaintenance(data)
                    yield put({ type: "updateState", payload: { maintenanceInfo } })
                }
            },
            { type: 'takeLatest' },
        ],
    },
};
